/**
 * Words for the door's team-definition line (kanban 16a22d06).
 */
import type { DoorTeamBriefRead } from '../../services/qcpTeam';

/** The definition's first non-empty line, for the collapsed state. */
export function briefHeadline(brief: DoorTeamBriefRead | null): string | null {
  const first = brief?.definition?.split('\n').map((l) => l.trim()).find((l) => l !== '') ?? null;
  if (!first) return null;
  // "Sigma team: Leading ..." reads twice beside the team name; drop the prefix.
  const prefix = `${brief!.team.toLowerCase()}:`;
  return first.toLowerCase().startsWith(prefix) ? first.slice(prefix.length).trim() : first;
}

